export default __webpack_public_path__ + "static/media/activities.3b4021bd.svg";